import { render, staticRenderFns } from "./UnpaidGroups.vue?vue&type=template&id=81e4523c&scoped=true&"
import script from "./UnpaidGroups.vue?vue&type=script&lang=js&"
export * from "./UnpaidGroups.vue?vue&type=script&lang=js&"
import style0 from "./UnpaidGroups.vue?vue&type=style&index=0&id=81e4523c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81e4523c",
  null
  
)

export default component.exports